import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { useAuth } from '../context/AuthContext';
import { menuConfig } from './menuConfig';
import * as FaIcons from 'react-icons/fa';
import './MainLayout.css';

const MainLayout = ({ children }) => {
    const { currentUser, userData } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const getDashboardTitle = (role) => {
        if (!role) return 'Dashboard';
        // Capitalize the first letter and handle multi-word roles
        const formattedRole = role.replace('-', ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        return `${formattedRole} Dashboard`;
    };

    const dashboardTitle = getDashboardTitle(userData?.role);

    return (
        <div className={`main-layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            <Sidebar menuConfig={menuConfig} userRole={userData?.role} isOpen={sidebarOpen} toggle={toggleSidebar} />
            <div className="main-content">
                <header className="header">
                    <div className="header-left">
                        <button onClick={toggleSidebar} className="sidebar-toggle-btn">
                            <FaIcons.FaBars />
                        </button>
                        <h1 className="header-title">{dashboardTitle}</h1>
                    </div>
                    <div className="header-right">
                        <div className="user-info">
                            <span className="user-name">{userData?.fullName || currentUser?.email}</span>
                            <span className="user-role">{userData?.role}</span>
                        </div>
                        {/* Add other header items like notifications, profile dropdown, etc. */}
                    </div>
                </header>
                <main className="page-content">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default MainLayout;
